import { render, staticRenderFns } from "./ProductCategoryNav.vue?vue&type=template&id=76b2a7b4"
import script from "./ProductCategoryNav.vue?vue&type=script&lang=js"
export * from "./ProductCategoryNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports